import { Content, AdminSideBar } from 'views/components/Layout';
import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../Routes/PrivateRoute';
import PageSpinner from '../PageSpinner';
import { adminRoutes } from 'views/routes';

class AdminLayout extends React.Component {
  static isSidebarOpen() {
    return document.querySelector('.cr-sidebar').classList.contains('cr-sidebar--open');
  }

  componentWillReceiveProps({ breakpoint }) {
    if (breakpoint !== this.props.breakpoint) {
      this.checkBreakpoint(breakpoint);
    }
  }

  componentDidMount() {
    this.checkBreakpoint(this.props.breakpoint);
  }

  // close sidebar when
  handleContentClick = event => {
    // close sidebar if sidebar is open and screen size is less than `md`
    if (
      AdminLayout.isSidebarOpen() &&
      (this.props.breakpoint === 'xs' || this.props.breakpoint === 'sm' || this.props.breakpoint === 'md')
    ) {
      this.openSidebar('close');
    }
  };

  checkBreakpoint(breakpoint) {
    switch (breakpoint) {
      case 'xs':
      case 'sm':
      case 'md':
        return this.openSidebar('close');

      case 'lg':
      case 'xl':
      default:
        return this.openSidebar('open');
    }
  }

  openSidebar(openOrClose) {
    if (openOrClose === 'open') {
      return document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
    }
    document.querySelector('.cr-sidebar').classList.remove('cr-sidebar--open');
  }

  render() {
    return (
      <div className="cr-app bg-app" style={{ overflow: 'hidden' }}>
        <AdminSideBar />

        <Content fluid onClick={this.handleContentClick}>
          <Switch>
            <React.Suspense fallback={<PageSpinner />}>
              {adminRoutes.map((route, idx) => {
                return (
                  <PrivateRoute
                    key={idx}
                    exact={route.exact}
                    path={`/admin${route.path}`}
                    component={route.component}
                  />
                );
              })}
            </React.Suspense>
          </Switch>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
